import { render } from "./AboutSite.vue?vue&type=template&id=8963f170&scoped=true"
import script from "./AboutSite.vue?vue&type=script&lang=js"
export * from "./AboutSite.vue?vue&type=script&lang=js"

import "./AboutSite.vue?vue&type=style&index=0&id=8963f170&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8963f170"]])

export default __exports__